import { LazyLoadImage } from "react-lazy-load-image-component";
import Product1JPG from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product1WEBP from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { actionAddToNextList, actionRemoveFromNextList, actionRemoveAllItemFromNextList } from '../../../../redux/actions/shoppingCart/nextListPurchase';
import { actionAddToShoppingCart, actionRemoveFromShoppingCart, actionRemoveAllItemFromShoppingCart } from '../../../../redux/actions/shoppingCart';
import { handleChangeDataPageCheckoutCart } from '../../../../redux/actions/pages/checkout/cart';

import { useDispatch, useSelector } from "react-redux";
import { IMAGE_ADDRESS } from '../../../../apis';
import { Link } from 'react-router-dom';
import { useCartHandlers } from '../../../../utils/cartHandler';
import EmptyCart from '../../../../styles/images/svg/empty-cart.svg';
import EmptySfl from "../../../../styles/images/empty-sfl.webp";


const CartMobile = () => {
 	
 	const dispatch = useDispatch();

 	const { carts, totalPrice } = useSelector(state => state.shoppingCart);
 	const { nextList } = useSelector(state => state.nextListPurchase);
 	const { selectedTab, isShowMoreMenuCart, isShowMoreMenuNextList } = useSelector(state => state.checkoutCart);

 	const { handleAddToCartTwo, handleMinusBtnTwo } = useCartHandlers(null, null, null);

 	const totalProductPrice = carts.reduce((sum, item) => {
	  	const price = item.marketPrice !== null ? item.marketPrice : item.price;
	  	return sum + (price * item.number);
	}, 0);
 	const profit = totalProductPrice - totalPrice;
 	const profitPercent = totalProductPrice > 0 ? Math.floor((totalProductPrice - totalPrice) * 100 / totalProductPrice) : 0;

 	const naMojud = 1 === 2; // design amade shode vase kalahaye namojud. age in shart bargahrar beshe ghabele moshahede hast

 	const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};

	const handleAddToNextList = (cartItem) => {
 		dispatch(actionAddToNextList(cartItem));
 		dispatch(actionRemoveFromShoppingCart(cartItem));
 	};

 	const handleChangeSelectedTab = (tab) => {
 		dispatch(handleChangeDataPageCheckoutCart('selectedTab', tab));
 	};

 	const handleRemoveFromNextList = (cartItem) => {
 		dispatch(actionRemoveFromNextList(cartItem));
 	};

 	const handleMoveFromNextListToCart = (cartItem) => {
 		dispatch(actionAddToShoppingCart(cartItem));
 		dispatch(actionRemoveFromNextList(cartItem));
 	};

 	const toggleMoreMenuCart = () => {
 		dispatch(handleChangeDataPageCheckoutCart('isShowMoreMenuCart', !isShowMoreMenuCart));
 	};

 	const moveAllCartItemToNextList = () => {
 		carts.map((item, key) => {
 			dispatch(actionAddToNextList(item));
 		});
 		dispatch(actionRemoveAllItemFromShoppingCart());
 		dispatch(handleChangeDataPageCheckoutCart('isShowMoreMenuCart', false));
 	};

 	const removeAllCartItem = () => {
 		dispatch(actionRemoveAllItemFromShoppingCart());
 		dispatch(handleChangeDataPageCheckoutCart('isShowMoreMenuCart', false));
 	};

 	const toggleMoreMenuNextList = () => {
 		dispatch(handleChangeDataPageCheckoutCart('isShowMoreMenuNextList', !isShowMoreMenuNextList));
 	};

 	const moveAllNextListItemToCart = () => {
 		nextList.map((item, key) => {
 			dispatch(actionAddToShoppingCart(item));
 		});
 		dispatch(actionRemoveAllItemFromNextList());
 		dispatch(handleChangeDataPageCheckoutCart('isShowMoreMenuNextList', false));
 	};

 	const removeNextListItem = () => {
 		dispatch(actionRemoveAllItemFromNextList());
 		dispatch(handleChangeDataPageCheckoutCart('isShowMoreMenuNextList', false));
 	};

    return (

    	<div className="grow flex flex-col" style={{paddingTop: '0px', paddingBottom: '128px'}}>
			<div className="grow bg-neutral-000 flex flex-col styles_BaseLayoutMobile__content__JgqoX">
				<div className="styles_PageLoader--hasPageContainer__gPBo1 hidden">
				</div>
				<div>
					<ul className="flex relative border-complete-b-200">
						<li onClick={() => handleChangeSelectedTab("cart")} className={`relative px-4 py-2 flex flex-row items-center grow justify-center lg:grow-0 ${selectedTab === "cart" ? "text-primary-500 text-subtitle-strong" : "text-subtitle text-neutral-500"} cursor-pointer`}>
							<div className="flex items-center select-none" data-cro-id="cart-main-cart">
								<span className="text-subtitle-strong">
									سبد خرید
								</span>
								{ carts.length > 0 &&
									<span className={`rounded-small text-neutral-000 mr-1 flex items-center justify-center text-body2-strong ${selectedTab === "cart" ? "styles_TabTitle--active__rzfBE" : "bg-neutral-400"} styles_TabTitle__bgsKt`} >
										{toPersianDigits(carts.length)}
									</span>
								}
							</div>
							<div className={`absolute bottom-0 ${selectedTab === "cart" ? "" : "opacity-0"} styles_Tab__border__6fH9m`}>
							</div>
						</li>
						<li onClick={() => handleChangeSelectedTab("nextList")} className={`relative px-4 py-2 flex flex-row items-center grow justify-center lg:grow-0 ${selectedTab === "nextList" ? "text-primary-500 text-subtitle-strong" : "text-subtitle text-neutral-500"} cursor-pointer`}>
							<div className="flex items-center select-none" data-cro-id="cart-next-purchase">
								<span className="text-subtitle">
									خرید بعدی
								</span>
								{ nextList.length > 0 &&
									<span className={`rounded-small text-neutral-000 mr-1 flex items-center justify-center text-body2-strong ${selectedTab === "nextList" ? "styles_TabTitle--active__rzfBE" : "bg-neutral-400"} styles_TabTitle__bgsKt`} >
										{toPersianDigits(nextList.length)}
									</span>
								}
							</div>
							<div className={`absolute bottom-0 ${selectedTab === "nextList" ? "" : "opacity-0"} styles_Tab__border__6fH9m`}>
							</div>
						</li>
					</ul>
					<ul className="lg:pt-3">
						<li>
							<div>
								<div className="lg:flex">
									<section className="mb-3 lg:mb-0 grow border-complete-b-200 lg:border-none lg:pl-3">
										

										{ selectedTab === "cart" ?
											<div className="p-0">
												{ carts.length === 0 ?
													<div className="py-6 lg:px-0 bg-neutral-000 rounded-large">
														<div className="flex justify-center">
															<div style={{width: '200px', height: '150px', lineHeight: '0'}}>
																<LazyLoadImage className="w-full inline-block" src={EmptyCart} width="200" height="150" alt="empty-cart" title="" style={{objectFit: 'contain'}} />
															</div>
														</div>
														<p className="text-h4 text-neutral-800 text-center mt-6">سبد خرید شما خالی است!</p>
													</div>
												:
													<div className="lg:rounded-medium relative styles_Frame__Lu_I7 overflow-hidden !border-none" id="border-none-1" >
														<div className="styles_SimpleList__4Oxc9 px-6">
															<div className="w-full flex items-start">
																<div className="flex grow items-center">
																	<div className="flex items-start grow">
																		<div className="grow text-right">
																			<div className="break-words py-3">
																				<div className="flex items-center grow">
																					<p className="grow text-h5 text-neutral-900">
																						<span className="relative">
																							<div>
																								<div>سبد خرید شما 
																									<span className="text-icon-low-emphasis text-body-2">
																										. 
																										 {toPersianDigits(carts.length)} 
																										 مرسوله
																									</span>
																								</div>
																							</div>
																						</span>
																					</p>
																					<div>
																						<button onClick={toggleMoreMenuCart} type="button">
																							<div className="flex">
																								<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
																									<use xlinkHref="#moreVert"></use>
																								</svg>
																							</div>
																						</button>
																						{ isShowMoreMenuCart &&
																							<>
																							<div class="p-2 z-3 absolute" style={{zIndex: "10", left: "0px"}}>
																								<div class="py-2 flex flex-col bg-neutral-000 rounded shadow-fab-button overflow-hidden focus:none">
																									<button onClick={moveAllCartItemToNextList} type="button" class="block px-5 py-2 w-full styles_SelectorMenuItem__aFUCP">
																										<div class="styles_SimpleList__4Oxc9">
																											<div class="w-full flex items-start">
																												<div class="flex grow items-center">
																													<div class="flex" aria-hidden="false">
																														<svg style={{width: "24px", height: "24px", fill: "var(--color-icon-high-emphasis)"}}>
																															<use xlinkHref="#saveForLater"></use>
																														</svg>
																													</div>
																													<div class="flex items-start grow mr-4">
																														<div class="grow text-right">
																															<div class="break-words py-3 xs:py-0">
																																<div class="flex items-center grow">
																																	<p class="grow text-body1-strong text-neutral-700">
																																		<span class="relative">انتقال همه به خرید بعدی</span>
																																	</p>
																																</div>
																															</div>
																														</div>
																													</div>
																												</div>
																											</div>
																										</div>
																									</button>
																									<button onClick={removeAllCartItem} type="button" class="block px-5 py-2 w-full styles_SelectorMenuItem__aFUCP">
																										<div class="styles_SimpleList__4Oxc9">
																											<div class="w-full flex items-start">
																												<div class="flex grow items-center">
																													<div class="flex" aria-hidden="false">
																														<svg style={{width: "24px", height: "24px", fill: "var(--color-icon-high-emphasis)"}}>
																															<use xlinkHref="#trash"></use>
																														</svg>
																													</div>
																													<div class="flex items-start grow mr-4">
																														<div class="grow text-right">
																															<div class="break-words py-3 xs:py-0">
																																<div class="flex items-center grow">
																																	<p class="grow text-body1-strong text-neutral-700">
																																		<span class="relative">حذف همه</span>
																																	</p>
																																</div>
																															</div>
																														</div>
																													</div>
																												</div>
																											</div>
																										</div>
																									</button>
																								</div>
																							</div>

																							<div
																			                    onClick={() => toggleMoreMenuCart()}
																			                    style={{
																			                        position: 'fixed',
																			                        inset: 0,
																			                        backgroundColor: 'rgba(0,0,0,0)',
																			                        zIndex: 3,
																			                    }}
																			                />
																			                </>
																						}
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
														<div className="lg:rounded-medium relative styles_Frame__Lu_I7 p-0 mb-3 !border-none" id="border-none-1">
															{ 
																carts.map((cart, key) => (
																	<div className="relative br-list-vertical-no-padding-200 px-4">
																		<div className="absolute top-0 left-0 bg-neutral-000 w-full h-full flex items-center justify-center pointer-events-none opacity-0">
																			<div className="flex flex-col justify-center items-center py-4">
																				<div style={{width: '36px', height: '36px', lineHeight: '0'}}>
																					<picture>
																						<source type="image/webp" srcSet={Product1WEBP} />
																						<source type="image/jpeg" srcSet={Product1JPG} />
																						<span className="w-full inline-block" style={{display: 'inline-block', objectFit: 'contain', width: '36px', height: '36px'}}>
																						</span>
																					</picture>
																				</div>
																				<p className="text-subtitle-strong text-neutral-800 my-3">کالای موردنظر شما حذف شد
																				</p>
																				<div className="bg-neutral-200 rounded styles_RemovingItemBox__progressBarContainer__9Y2LV">
																					<div className="bg-neutral-400 rounded">
																					</div>
																				</div>
																				<button className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai styles_btn--white__6nwxQ rounded-medium focus:outline-none font-bold">
																					<div className="flex items-center justify-center relative grow">بازگرداندن کالا
																						<div className="flex text-neutral-600 mr-2">
																							<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
																								<use xlinkHref="#undo"></use>
																							</svg>
																						</div>
																					</div>
																				</button>
																			</div>
																		</div>
																		<div className="bg-neutral-000 py-4 lg:pr-4 mx-4 lg:mx-0" data-testid="cart-item">
																			<div className="styles_CartItem__grid__rZXPE">
																				<div className="flex flex-col items-center">
																					<Link className="relative" to={`/product/${cart.slug}/${cart.title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`} >
																						<div style={{width: '114px', height: '114px', lineHeight: '0'}}>
																							<picture>
																								<LazyLoadImage className="w-full inline-block" src={IMAGE_ADDRESS + cart.image} width="114" height="114" alt={cart.title} title="" style={{objectFit: 'contain'}} />
																							</picture>
																						</div>
																						<div className="bg-neutral-000 absolute bottom-0 left-0 rounded-small text-center text-neutral-900 text-caption-strong hidden styles_CartItem__imageQuantity__bzt41">۱
																						</div>
																					</Link>
																					<div className="mr-2">
																						<div className="flex items-center text-h5 py-2 mt-2 flex-col">
																							<div>
																							</div>
																						</div>
																					</div>
																				</div>
																				<div className="overflow-x-hidden">
																					<div className="">
																						<h3 className="text-neutral-800 text-body1-strong mb-2">{cart.title}</h3>
																						{ cart.selectedVariant.attributeTile &&
																							<div className="flex">
																								<div className="flex mt-1">
																								{ cart.selectedVariant.optionColor ?
																									<svg style={{width: '18px', height: '18px', fill: `#${cart.selectedVariant.optionColor}`}}>
																										<use xlinkHref="#variationColor"></use>
																									</svg>
																									:
																									<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-low-emphasis)'}}>
																	                                    <use xlinkHref="#variationSize"></use>
																	                                </svg>
																								}
																								</div>
																								<p className="text-body-2 text-neutral-600 mr-2">{cart.selectedVariant.optionTitle}
																								</p>
																							</div>
																						}

																						<div className="flex">
																							<div className="flex mt-1">
																								<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-low-emphasis)'}}>
																									<use xlinkHref="#seller"></use>
																								</svg>
																							</div>
																							<p className="text-body-2 text-neutral-600 mr-2">{cart.seller.title}
																							</p>
																						</div>

																					</div>
																				</div>
																				<div className="flex flex-col items-center">
																					<div className="flex items-center justify-between user-select-none px-2 rounded-medium border-complete-200 item-quantity_ItemQuantity__box__5r4FJ">
																						<div onClick={() => handleAddToCartTwo(cart.seller, cart.selectedVariant, cart.product, cart.slug)} className="flex cursor-pointer  p-0 lg:p-0">
																							<svg data-testid="quantity-increase" data-cro-id="cart-add-quantity" style={{width: '18px', height: '18px', fill: 'var(--color-icon-primary)'}}>
																								<use xlinkHref="#addSimple"></use>
																							</svg>
																						</div>
																						<span className="flex flex-col items-center justify-between text-primary-500">
																							<span className="relative flex items-center justify-center text-h5 item-quantity_ItemQuantity__boxCount__9ZT6i">{toPersianDigits(cart.number)}
																							</span>

																						</span>
																						<div onClick={() => handleMinusBtnTwo(cart.seller, cart.selectedVariant, cart.product, cart.slug)} className="flex cursor-pointer">
																							<svg data-testid="quantity-decrease" data-cro-id="cart-delete-item-right" style={{width: '18px', height: '18px', fill: 'var(--color-icon-primary)'}}>
																								<use xlinkHref={`#${cart.number > 1 ? 'removeSimple' : 'delete'}`}></use>
																							</svg>
																						</div>
																					</div>
																				</div>
																				<div>
																					<div className="flex items-center justify-between">
																						<div>
																							<div className="flex items-center justify-start ml-4">
																								<div className="flex justify-start items-center gap-1">
																									<span className="text-h4 text-neutral-800">{toPersianDigits((cart.price * cart.number / 10).toLocaleString('fa'))}
																									</span>
																								</div>
																								<div className="flex items-center justify-between">
																									<div className="flex items-center">
																										<div className="flex">
																											<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-high-emphasis)'}}>
																												<use xlinkHref="#toman"></use>
																											</svg>
																										</div>
																									</div>
																								</div>
																							</div>
																						</div>
																						<div className="flex a-center flex-row-reverse ml-4">
																						</div>
																					</div>
																				</div>
																			</div>

																			<div className="flex lg:justify-start mt-3">
																				<div className="flex mr-auto">
																					<button onClick={() => handleAddToNextList(cart)} className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--text__W2jhM styles_btn--secondary__Warw0 rounded-medium mr-auto" data-cro-id="cart-next-purchase-cta">
																						<div className="flex items-center justify-center relative grow">انتقال به خرید بعدی
																							<div className="flex mr-2">
																								<ChevronLeftIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-secondary)'}} />
																							</div>
																						</div>
																					</button>
																				</div>
																			</div>
																		</div>
																	</div>
																))
															}
														</div>
													</div>
												}
											</div>

										:

											<div className="p-0">
												{ nextList.length === 0 ?
													<div class="p-6 lg:border-complete rounded-medium">
														<div class="flex justify-center">
															<div aria-hidden="false" aria-label="empty-cart" style={{width: "200px", height: "150px", lineHeight: "0"}}>
																<picture>
																	<source type="image/webp" srcset={EmptySfl} />
																	<source type="image/jpeg" srcset={EmptySfl} />
																	<LazyLoadImage class="w-full inline-block" src={EmptySfl} width="200" height="150" alt="empty-cart" title="" style={{objectFit: "contain"}} />
																</picture>
															</div>
														</div>
														<p class="text-h4 text-neutral-800 text-center mt-6">
															لیست خرید بعدی شما خالی است!
														</p>
														<p class="text-body-2 text-neutral-600 text-center mt-2 mx-auto">
															شما می‌توانید محصولاتی که به سبد خرید خود افزوده‌اید و فعلا قصد خرید آن‌ها را ندارید، در لیست خرید بعدی قرار داده و هر زمان مایل بودید آن‌ها را به سبد خرید اضافه کرده و خرید آن‌ها را تکمیل کنید.
														</p>
													</div>
												:
													<div className="lg:rounded-medium relative styles_Frame__Lu_I7 overflow-hidden !border-none" id="border-none-1" >
														<div className="styles_SimpleList__4Oxc9 px-6">
															<div className="w-full flex items-start">
																<div className="flex grow items-center">
																	<div className="flex items-start grow">
																		<div className="grow text-right">
																			<div className="break-words py-3">
																				<div className="flex items-center grow">
																					<p className="grow text-h5 text-neutral-900">
																						<span className="relative">
																							<div>
																								<div>لیست خرید بعدی شما
																									<span className="text-icon-low-emphasis text-body-2">
																										. 
																										 {toPersianDigits(nextList.length)} 
																										 مرسوله
																									</span>
																								</div>
																							</div>
																						</span>
																					</p>
																					<div>
																						<button onClick={toggleMoreMenuNextList} type="button">
																							<div className="flex">
																								<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
																									<use xlinkHref="#moreVert"></use>
																								</svg>
																							</div>
																						</button>
																						{ isShowMoreMenuNextList &&
																							<>
																							<div class="p-2 z-3 absolute" style={{zIndex: "10", left: "0px"}}>
																								<div class="py-2 flex flex-col bg-neutral-000 rounded shadow-fab-button overflow-hidden focus:none">
																									<button onClick={moveAllNextListItemToCart} type="button" class="block px-5 py-2 w-full styles_SelectorMenuItem__aFUCP">
																										<div class="styles_SimpleList__4Oxc9">
																											<div class="w-full flex items-start">
																												<div class="flex grow items-center">
																													<div class="flex" aria-hidden="false">
																														<svg style={{width: "24px", height: "24px", fill: "var(--color-icon-high-emphasis)"}}>
																															<use xlinkHref="#saveForLater"></use>
																														</svg>
																													</div>
																													<div class="flex items-start grow mr-4">
																														<div class="grow text-right">
																															<div class="break-words py-3 xs:py-0">
																																<div class="flex items-center grow">
																																	<p class="grow text-body1-strong text-neutral-700">
																																		<span class="relative">انتقال همه به  سبد خرید</span>
																																	</p>
																																</div>
																															</div>
																														</div>
																													</div>
																												</div>
																											</div>
																										</div>
																									</button>
																									<button onClick={removeNextListItem} type="button" class="block px-5 py-2 w-full styles_SelectorMenuItem__aFUCP">
																										<div class="styles_SimpleList__4Oxc9">
																											<div class="w-full flex items-start">
																												<div class="flex grow items-center">
																													<div class="flex" aria-hidden="false">
																														<svg style={{width: "24px", height: "24px", fill: "var(--color-icon-high-emphasis)"}}>
																															<use xlinkHref="#trash"></use>
																														</svg>
																													</div>
																													<div class="flex items-start grow mr-4">
																														<div class="grow text-right">
																															<div class="break-words py-3 xs:py-0">
																																<div class="flex items-center grow">
																																	<p class="grow text-body1-strong text-neutral-700">
																																		<span class="relative">حذف همه</span>
																																	</p>
																																</div>
																															</div>
																														</div>
																													</div>
																												</div>
																											</div>
																										</div>
																									</button>
																								</div>
																							</div>

																							<div
																			                    onClick={() => toggleMoreMenuCart()}
																			                    style={{
																			                        position: 'fixed',
																			                        inset: 0,
																			                        backgroundColor: 'rgba(0,0,0,0)',
																			                        zIndex: 3,
																			                    }}
																			                />
																			                </>
																						}
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
														<div className="lg:rounded-medium relative styles_Frame__Lu_I7 p-0 mb-3 !border-none" id="border-none-1">
															{ 
																nextList.map((cart, key) => (
																	<div className="relative br-list-vertical-no-padding-200 px-4">
																		<div className="absolute top-0 left-0 bg-neutral-000 w-full h-full flex items-center justify-center pointer-events-none opacity-0">
																			<div className="flex flex-col justify-center items-center py-4">
																				<div style={{width: '36px', height: '36px', lineHeight: '0'}}>
																					<picture>
																						<source type="image/webp" srcSet={Product1WEBP} />
																						<source type="image/jpeg" srcSet={Product1JPG} />
																						<span className="w-full inline-block" style={{display: 'inline-block', objectFit: 'contain', width: '36px', height: '36px'}}>
																						</span>
																					</picture>
																				</div>
																				<p className="text-subtitle-strong text-neutral-800 my-3">کالای موردنظر شما حذف شد
																				</p>
																				<div className="bg-neutral-200 rounded styles_RemovingItemBox__progressBarContainer__9Y2LV">
																					<div className="bg-neutral-400 rounded">
																					</div>
																				</div>
																				<button className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai styles_btn--white__6nwxQ rounded-medium focus:outline-none font-bold">
																					<div className="flex items-center justify-center relative grow">بازگرداندن کالا
																						<div className="flex text-neutral-600 mr-2">
																							<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
																								<use xlinkHref="#undo"></use>
																							</svg>
																						</div>
																					</div>
																				</button>
																			</div>
																		</div>
																		<div className="bg-neutral-000 py-4 lg:pr-4 mx-4 lg:mx-0" data-testid="cart-item">
																			<div className="styles_CartItem__grid__rZXPE">
																				<div className="flex flex-col items-center">
																					<Link className="relative" to={`/product/${cart.slug}/${cart.title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`} >
																						<div style={{width: '114px', height: '114px', lineHeight: '0'}}>
																							<picture>
																								<LazyLoadImage className="w-full inline-block" src={IMAGE_ADDRESS + cart.image} width="114" height="114" alt={cart.title} title="" style={{objectFit: 'contain'}} />
																							</picture>
																						</div>
																						<div className="bg-neutral-000 absolute bottom-0 left-0 rounded-small text-center text-neutral-900 text-caption-strong hidden styles_CartItem__imageQuantity__bzt41">۱
																						</div>
																					</Link>
																					<div className="mr-2">
																						<div className="flex items-center text-h5 py-2 mt-2 flex-col">
																							<div>
																							</div>
																						</div>
																					</div>
																				</div>
																				<div className="overflow-x-hidden">
																					<div className="">
																						<h3 className="text-neutral-800 text-body1-strong mb-2">{cart.title}</h3>
																						{ cart.selectedVariant.attributeTile &&
																							<div className="flex">
																								<div className="flex mt-1">
																								{ cart.selectedVariant.optionColor ?
																									<svg style={{width: '18px', height: '18px', fill: `#${cart.selectedVariant.optionColor}`}}>
																										<use xlinkHref="#variationColor"></use>
																									</svg>
																									:
																									<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-low-emphasis)'}}>
																	                                    <use xlinkHref="#variationSize"></use>
																	                                </svg>
																								}
																								</div>
																								<p className="text-body-2 text-neutral-600 mr-2">{cart.selectedVariant.optionTitle}
																								</p>
																							</div>
																						}

																						<div className="flex">
																							<div className="flex mt-1">
																								<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-low-emphasis)'}}>
																									<use xlinkHref="#seller"></use>
																								</svg>
																							</div>
																							<p className="text-body-2 text-neutral-600 mr-2">{cart.seller.title}
																							</p>
																						</div>

																					</div>
																				</div>
																				<div className="flex flex-col items-center">
																				</div>
																				<div>
																					<div className="flex items-center justify-between">
																						<div>
																							<div className="flex items-center justify-start ml-4">
																								<div className="flex justify-start items-center gap-1">
																									<span className="text-h4 text-neutral-800">{toPersianDigits((cart.price * cart.number / 10).toLocaleString('fa'))}
																									</span>
																								</div>
																								<div className="flex items-center justify-between">
																									<div className="flex items-center">
																										<div className="flex">
																											<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-high-emphasis)'}}>
																												<use xlinkHref="#toman"></use>
																											</svg>
																										</div>
																									</div>
																								</div>
																							</div>
																						</div>
																						<div className="flex a-center flex-row-reverse ml-4">
																						</div>
																					</div>
																				</div>
																			</div>


																			<div class="flex lg:justify-start mt-3">
																				<button onClick={() => handleRemoveFromNextList(cart)} class="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--medium__4GoNC styles_btn--neutralOutlined__mLWvq styles_btn--primary__y0GEv rounded-medium ml-6" data-cro-id="cart-delete-item-central">
																					<div class="flex items-center justify-center relative grow">
																						<div class="flex ml-2" aria-hidden="false">
																							<svg style={{width: "24px", height: "24px", fill: "var(--color-icon-low-emphasis)"}}>
																								<use xlinkHref="#delete"></use>
																							</svg>
																						</div>
																						<p class="text-button-2 text-neutral-500">حذف</p>
																					</div>
																				</button>
																				<button onClick={() => handleMoveFromNextListToCart(cart)} class="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--medium__4GoNC styles_btn--outlined__saFC3 styles_btn--primary__y0GEv rounded-medium">
																					<div class="flex items-center justify-center relative grow">
																						<div class="flex ml-2" aria-hidden="false">
																							<svg style={{width: "24px", height: "24px", fill: "var(--color-icon-primary)"}}>
																								<use xlinkHref="#moveToCart"></use>
																							</svg>
																						</div>افزودن به سبد
																					</div>
																				</button>
																				<div class="flex mr-auto">
																				</div>
																			</div>

																		</div>
																	</div>
																))
															}
														</div>
													</div>
												}
											</div>
										}
									</section>


									{ selectedTab === "cart" && carts.length > 0 &&
									<aside className="relative">
										<div className="sticky styles_CheckoutGrid__sideBar__ah_Qn" style={{top: '188px'}}>
											<div className="lg:border-complete-200 lg:rounded-medium pt-2">
												<div className="px-5">
													<div className="flex items-center justify-between pt-3 relative flex-wrap">
														<div className="flex items-center">
															<div className="mr-1 text-body2-strong flex items-center text-neutral-600">
																<span>قیمت کالاها ({toPersianDigits(carts.length)})
																</span>
															</div>
														</div>
														<div className="flex items-center mr-auto">
															<div className="flex items-center flex-wrap justify-end">
																<div>
																	<div className="flex items-center justify-start">
																		<div className="flex justify-start items-center gap-1">
																			<span className="!text-body-1 text-neutral-600 text-subtitle-strong">{toPersianDigits((totalProductPrice / 10).toLocaleString('fa'))}
																			</span>
																		</div>
																		<div className="flex items-center justify-between">
																			<div className="flex items-center">
																				<div className="flex">
																					<svg style={{width: '16px', height: '16px', fill: 'var(--color-neutral-600)'}}>
																						<use xlinkHref="#toman"></use>
																					</svg>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div className="flex items-center justify-between pt-3 relative flex-wrap">
														<div className="flex items-center">
															<div className="mr-1 text-body2-strong flex items-center text-neutral-800">
																<span>جمع سبد خرید
																</span>
															</div>
														</div>
														<div className="flex items-center mr-auto">
															<div className="flex items-center flex-wrap justify-end">
																<div>
																	<div className="flex items-center justify-start">
																		<div className="flex justify-start items-center gap-1">
																			<span className="!text-body-1 text-neutral-800 text-subtitle-strong">{toPersianDigits((totalPrice / 10).toLocaleString())}
																			</span>
																		</div>
																		<div className="flex items-center justify-between">
																			<div className="flex items-center">
																				<div className="flex">
																					<svg style={{width: '16px', height: '16px', fill: 'var(--color-neutral-800)'}}>
																						<use xlinkHref="#toman"></use>
																					</svg>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
													{ profit > 0 &&
														<div className="flex items-center justify-between pt-3 relative flex-wrap">
															<div className="flex items-center">
																<div className="mr-1 text-body2-strong flex items-center text-neutral-600">
																	<span className="text-hint-text-success text-body-1">سود شما از خرید</span>
																</div>
															</div>
															<div className="flex items-center mr-auto">
																<span className="ml-1 !text-body-1 text-neutral-600 text-subtitle-strong !text-hint-text-success">({toPersianDigits(profitPercent)}٪)</span>
																<div className="flex items-center flex-wrap justify-end">
																	<div>
																		<div className="flex items-center justify-start">
																			<div className="flex justify-start items-center gap-1">
																				<span className="!text-body-1 text-neutral-600 text-subtitle-strong !text-hint-text-success">{toPersianDigits((profit / 10).toLocaleString('fa'))}</span>
																			</div>
																			<div className="flex items-center justify-between">
																				<div className="flex items-center">
																					<div className="flex">
																						<svg style={{width: '16px', height: '16px', fill: 'rgb(46, 123, 50)'}}>
																							<use xlinkHref="#toman"></use>
																						</svg>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													}
													<div className="hidden lg:block mt-1 lg:my-4">
														<a className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai styles_btn--primary__y0GEv rounded-medium w-full" data-cro-id="cart-continue-shopping" href="/checkout/shipping/">
															<div className="flex items-center justify-center relative grow">تایید و تکمیل سفارش
															</div>
														</a>
													</div>
												</div>
											</div>
											<p className="text-neutral-500 text-caption my-3 hidden lg:block">هزینه این سفارش هنوز پرداخت نشده‌ و در صورت اتمام موجودی، کالاها از سبد حذف می‌شوند
											</p>
											<div className="bg-neutral-100 lg:bg-neutral-000 flex flex-col px-5 lg:px-0">
											</div>
										</div>
									</aside>
									}


								</div>
							</div>
							
						</li>
					</ul>
				</div>
			</div>
		</div>

    );
}

export default CartMobile;